import styled from 'styled-components'
import COLORS from '@colors'

export const Calendar = styled.div`
  position: relative;
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  top: 40px;
  height: 92px;
  max-width: 53%;
  width: fit-content;
`

export const CalendarItem = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 96px;
  height: 92px;
  z-index: 2;
  letter-spacing: 0;
  padding: 15px 14px 12px 14px;
  border: 1px solid ${COLORS.whiteD};
  color: ${props => (props.active ? COLORS.leather : COLORS.gray87)};
  border-radius: 4px;
  font-family: 'Barlow';
  background-color: ${props =>
    props.active ? COLORS.transparentLeather : COLORS.white};
`
export const Line = styled.hr`
  border: 0;
  z-index: 4;
  height: 1px;
  border-top: 1px solid ${COLORS.whiteD};
  width: 20px;
`
